import { useEffect, useState } from "react";

export const useDebouncedValue = <T>(value: T) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    if (JSON.stringify(value) === JSON.stringify(debouncedValue)) return;

    const id = setTimeout(() => {
      setDebouncedValue(value);
    }, 200);
    return () => {
      clearTimeout(id);
    };
  }, [value, debouncedValue]);

  return debouncedValue;
};
